import { adminHttpClient } from "../../../commons/adminHttpClinet";
import { AddNewMarketplacePurchase, MarketplacePurchaseModel, MarketplacePurchaseSearch } from "../../../models/dashboard/marketplacePurchase/marketplacePurchaseModel";


const addNewMarketplaceTransaction = (model:AddNewMarketplacePurchase): Promise<any> => {
    return adminHttpClient.post(`/api/Admin/AdminMarketplacePurchase/add-marketplace-purchase`, model)
}
export default addNewMarketplaceTransaction;